import type { Accuracy, Pead } from "epsm-api-types/models";
import { NO_DATA } from "../../../consts";

export function getAccuracyForCurrentPead(
	data: Pead[],
	activePead: Pead | null,
): string | number {
	if (!activePead) return NO_DATA;

	const getPercentValue = (value: number) => Math.trunc(value * 100);

	const findAccuracy = (pead: Pead): number | undefined => {
		return pead.accuracy?.find(
			(acc: Accuracy) => !acc.depends_on_type && acc.drift_point === "qtr_end",
		)?.value;
	};

	// Check active PEAD first
	const activeAccuracy = findAccuracy(activePead);
	if (activeAccuracy !== undefined) {
		return getPercentValue(activeAccuracy);
	}

	// If no accuracy in active PEAD, look for previous PEAD
	const previousPead = data.find(
		(pead) =>
			(pead.earning_day.getTime() < activePead.earning_day.getTime() &&
				pead.overall_count === activePead.overall_count) ||
			activePead.overall_count - pead.overall_count === 1,
	);

	if (!previousPead) return NO_DATA;

	const previousAccuracy = findAccuracy(previousPead);

	return previousAccuracy ? getPercentValue(previousAccuracy) : NO_DATA;
}
